<div class="cliente-filter">
  <div class="cliente-filter-quick">
    <div class="cliente-filter-quick-block cliente-filter-quick-block-options">
      <!-- Cadastros -->
      <div
        class="cliente-filter-quick-block-options-multiselect-item"
        *ngIf="!hideCadastro()"
      >
        <sgt-cliente-cadastro-multiselect
          [(cadastros)]="filter.cadastros"
          (cadastrosChange)="onChangeCadastros()"
          defaultTitle="Cadastros"
          [disabled]="!isFilterInitialized"
        >
        </sgt-cliente-cadastro-multiselect>
      </div>

      <!-- Situações -->
      <div
        class="cliente-filter-quick-block-options-multiselect-item"
        *ngIf="!hideSituacao()"
      >
        <sgt-cliente-situacao-multiselect
          [(situacoes)]="filter.situacoes"
          (situacoesChange)="onChangeSituacoes()"
          defaultTitle="Situações"
          [disabled]="!isFilterInitialized"
        >
        </sgt-cliente-situacao-multiselect>
      </div>

      <!-- Classificações -->
      <div class="cliente-filter-quick-block-options-multiselect-item">
        <sgt-classificacao-tipo-multiselect
          [(idsClassificacoes)]="filter.idsClassificacoes"
          (idsClassificacoesChange)="onChangeClassificacoes()"
          [(nullOption)]="filter.classificacaoNull"
          [showNullOption]="true"
          [tipoClassificacaoCadastroCliente]="true"
          defaultTitle="Segmentos"
          [disabled]="!isFilterInitialized"
        >
        </sgt-classificacao-tipo-multiselect>
      </div>

      <!-- Tags -->
      <div class="d-flex">
        <sgt-tags-multi-select
          #tagsMultiSelect
          [cadastros]="isCadastroItem"
          [situacoes]="situacao"
          (changed)="onChangeTags($event)"
        >
        </sgt-tags-multi-select>
      </div>

      <!-- Representantes -->
      <div
        class="cliente-filter-quick-block-options-multiselect-item"
        *ngIf="!isRepresentante"
      >
        <sgt-representante-multiselect
          [(idsRepresentantes)]="filter.idsOutrosRepresentantes"
          (idsRepresentantesChange)="onChangeRepresentantes()"
          defaultTitle="Representantes"
          [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
          [showSemRepresentante]="true"
          [(semRepresentante)]="filter.semRepresentante"
          [disabled]="!isFilterInitialized"
        >
        </sgt-representante-multiselect>
      </div>

      <div class="cliente-filter-quick-block-filter-psq">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.filterPsq"
          #filterPsq="ngModel"
          name="filterPsq"
          id="filterPsq"
          placeholder="Digite para pesquisar..."
        />
      </div>

      <div class="cliente-filter-quick-block-options-btns">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-light"
            (click)="refresh()"
            title="Atualizar"
            [disabled]="!isFilterInitialized"
          >
            <i class="fas fa-sync"></i>
          </button>
          <button
            type="button"
            class="btn btn-light"
            (click)="clear()"
            title="Limpar filtro e atualizar"
            [disabled]="!isFilterInitialized"
          >
            <i class="fas fa-eraser" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="btn"
            [class.btn-light]="!filter.isFilterDirty"
            [class.btn-danger]="filter.isFilterDirty"
            (click)="toggleCollapse()"
            title="Filtro avançado"
            [disabled]="!isFilterInitialized"
          >
            <ng-template [ngIf]="isFilterInitialized">
              <i class="fas fa-filter" aria-hidden="true"></i>
              <i [class]="collapseIcon" aria-hidden="true"></i>
            </ng-template>
            <ng-template [ngIf]="isFilterInitializing">
              <i class="fas fa-spinner fa-pulse"></i>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="cliente-filter-collapse" #filterCollapse>
    <div class="row">
      <div class="form-group col-md">
        <label class="col-form-label">Tipo</label>
        <sgt-pessoa-tipo-multiselect
          [(tipos)]="filter.tiposPessoas"
          (tiposChange)="filter.isFilterDirty = true"
        >
        </sgt-pessoa-tipo-multiselect>
      </div>
      <div class="form-group col-12 col-md">
        <label for="filterCodigoIntegracaoErp" class="col-form-label"
          >Código ERP</label
        >
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.codigoIntegracaoErp"
          name="filterCodigoIntegracaoErp"
          id="filterCodigoIntegracaoErp"
          (ngModelChange)="filter.isFilterDirty = true"
        />
      </div>
      <div class="form-group col-12 col-md">
        <label for="filterCnpjCpf" class="col-form-label">CNPJ/CPF</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.cnpjCpf"
          name="filterCnpjCpf"
          id="filterCnpjCpf"
          (ngModelChange)="filter.isFilterDirty = true"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md">
        <label class="col-form-label">Origens</label>
        <sgt-origem-multiselect
          [(origens)]="filter.origens"
          (origensChange)="filter.isFilterDirty = true"
        >
        </sgt-origem-multiselect>
        <p class="form-text text-muted">Origens dos prospects e clientes</p>
      </div>
      <div class="form-group col-12 col-md">
        <label class="col-form-label">Canais de Venda de Origem</label>
        <sgt-canal-venda-multiselect
          [(idsCanaisVendas)]="filter.idsCanaisVendaOrigem"
          (idsCanaisVendasChange)="filter.isFilterDirty = true"
        >
        </sgt-canal-venda-multiselect>
        <p class="form-text text-muted">
          Canais de Venda de origem dos prospects e clientes
        </p>
      </div>
      <div class="form-group col-md">
        <label class="col-form-label">Canais de Mídias Sociais</label>
        <sgt-canal-midia-social-multiselect
          [(canaisMidiasSociais)]="filter.canaisMidiasSociais"
          (canaisMidiasSociaisChange)="filter.isFilterDirty = true"
          [(nullOption)]="filter.canalMidiaSocialNull"
          [showNullOption]="true"
        >
        </sgt-canal-midia-social-multiselect>
        <p class="form-text text-muted">
          Canais de Mídias Sociais de origem dos prospects e clientes
        </p>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md">
        <label class="col-form-label">Campanhas Origens</label>
        <sgt-campanha-multiselect
          [(idsCampanhas)]="filter.idsCampanhasOrigens"
          (idsCampanhasChange)="filter.isFilterDirty = true"
          [(nullOption)]="filter.campanhaOrigemNull"
          nameSomenteEmAndamento="somenteCampanhasOrigemEmAndamento"
          idSomenteEmAndamento="somenteCampanhasOrigemEmAndamento"
          [(somenteEmAndamento)]="filter.somenteCampanhasOrigemEmAndamento"
          [showNullOption]="true"
        >
        </sgt-campanha-multiselect>
        <p class="form-text text-muted">
          Campanhas de origem dos prospects e clientes
        </p>
      </div>
      <div class="form-group col-md">
        <label class="col-form-label">Campanhas Aquisições</label>
        <sgt-campanha-multiselect
          [(idsCampanhas)]="filter.idsCampanhasAquisicoes"
          (idsCampanhasChange)="filter.isFilterDirty = true"
          [(nullOption)]="filter.campanhaAquisicaoNull"
          [(somenteEmAndamento)]="filter.somenteCampanhasAquisicaoEmAndamento"
          nameSomenteEmAndamento="somenteCampanhasAquisicaoEmAndamento"
          idSomenteEmAndamento="somenteCampanhasAquisicaoEmAndamento"
          [showNullOption]="true"
        >
        </sgt-campanha-multiselect>
        <p class="form-text text-muted">Campanhas de aquisição dos clientes</p>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md">
        <label class="col-form-label">Periodicidades de Compras</label>
        <sgt-periodicidade-compra-multi-select
          #periodicidadeCompraMultiSelectRef
          (changed)="onChangePeriodicidadesCompras($event)"
          [settings]="{
            showFooter: false,
            emitAfterClosed: true
          }"
        >
        </sgt-periodicidade-compra-multi-select>
      </div>
      <div class="form-group col-12 col-md">
        <label class="col-form-label">Periodicidades de Compras Semanas</label>
        <sgt-semana-multi-select
          #semanasMultiSelectRef
          (changed)="onChangePeriodicidadesComprasSemanas($event)"
          [settings]="{
            showFooter: false,
            emitAfterClosed: true
          }"
        >
        </sgt-semana-multi-select>
      </div>
    </div>

    <div class="row">
      <!-- <div class="form-group col-12 col-md-3">
                <label for="filterClienteAbc" class="col-form-label">Cliente ABC</label>
                <select class="form-control" name="filterClienteAbc" id="filterClienteAbc"
                    [ngModel]="filter.clienteAbc || ''" (ngModelChange)="filter.clienteAbc = $event ? $event : null; filter.isFilterDirty = true;">
                    <option value="">Todos</option>
                    <option *ngFor="let abc of clienteAbcs" [ngValue]="abc.id">{{abc.nome}}</option>
                </select>
            </div>                 -->
      <div class="form-group col-12 col-md">
        <label for="filterClienteGrupoEconomico" class="col-form-label"
          >Grupo Econômico</label
        >
        <select
          class="form-control"
          name="filterClienteGrupoEconomico"
          id="filterClienteGrupoEconomico"
          [ngModel]="filter.idClienteGrupoEconomico || ''"
          (ngModelChange)="
            filter.idClienteGrupoEconomico = $event ? $event : null;
            filter.isFilterDirty = true
          "
        >
          <option value="">Todos</option>
          <option
            *ngFor="let grupoEconomico of gruposEconomicos"
            [ngValue]="grupoEconomico.id"
          >
            {{ grupoEconomico.nome }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div
        class="form-group col-12 col-md-3"
        *ngIf="config?.canVisualizarStatusesAnaliseFinanceira"
      >
        <label for="statusesAnaliseFinanceira" class="col-form-label"
          >Análise Financeira</label
        >
        <sgt-cliente-analise-financeira-status-multiselect
          [(statuses)]="filter.statusesAnaliseFinanceira"
          (statusesChange)="onChangeStatusesAnaliseFinanceira()"
        >
        </sgt-cliente-analise-financeira-status-multiselect>
      </div>

      <div class="form-group col-12 col-md-3">
        <label for="dataCadastroInicial" class="col-form-label"
          >Cadastro Inicial</label
        >
        <sgt-datepicker
          [(ngModel)]="filter.dataCadastroInicial"
          name="dataCadastroInicial"
          id="dataCadastroInicial"
          #dataCadastroInicial="ngModel"
          [ngControl]="dataCadastroInicial"
          (ngModelChange)="onChangeDataCadastro($event)"
        >
        </sgt-datepicker>
      </div>
      <div class="form-group col-12 col-md-3">
        <label for="dataCadastroFinal" class="col-form-label"
          >Cadastro Final</label
        >
        <sgt-datepicker
          [(ngModel)]="filter.dataCadastroFinal"
          name="dataCadastroFinal"
          id="dataCadastroFinal"
          #dataCadastroFinal="ngModel"
          [ngControl]="dataCadastroFinal"
          (ngModelChange)="onChangeDataCadastro($event)"
        >
        </sgt-datepicker>
      </div>
    </div>

    <!-- Central de Compra v2 -->
    <div class="row" *ngIf="config?.isModoCentralCompraCadastro">
      <div class="form-group col-12">
        <label for="filterCentralCompras" class="col-form-label"
          >Central de Compras</label
        >
        <sgt-cliente-central-compra-typeahead
          [(ngModel)]="filter.clienteCentralCompras"
          name="filterCentralCompras"
          id="filterCentralCompras"
          #filterCentralCompras="ngModel"
          [ngControl]="filterCentralCompras"
          (typeaheadChange)="onChangeClienteCentralCompras($event)"
        >
        </sgt-cliente-central-compra-typeahead>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12 col-md-6 col-xl">
        <label for="filterRegiao" class="col-form-label">Região</label>
        <sgt-regiao-multiselect
          [(idsRegioes)]="filter.idsRegioes"
          (idsRegioesChange)="filter.isFilterDirty = true"
          [(nullOption)]="filter.regiaoNull"
          [(somenteAtivas)]="filter.somenteRegioesAtivas"
          nameSomenteAtivas="filterRegiaoSomenteAtivas"
          idSomenteAtivas="filterRegiaoSomenteAtivas"
          [dropup]="true"
        >
        </sgt-regiao-multiselect>
      </div>
      <div class="form-group col-12 col-md-6 col-xl">
        <label for="filterEstado" class="col-form-label">Estado</label>
        <select
          class="form-control"
          name="filterEstado"
          id="filterEstado"
          [ngModel]="filter.idEstado || ''"
          (ngModelChange)="
            filter.idEstado = $event ? $event : null;
            filter.isFilterDirty = true
          "
        >
          <option value="">Todos</option>
          <option *ngFor="let estado of estados" [ngValue]="estado.id">
            {{ estado.nome }}
          </option>
        </select>
      </div>
      <div class="form-group col-12 col-md-12 col-xl">
        <label for="filterCidade" class="col-form-label">Cidade</label>
        <sgt-typeahead-cidade
          [(ngModel)]="filter.cidade"
          name="filterCidade"
          id="filterCidade"
          #filterCidade="ngModel"
          [ngControl]="filterCidade"
          [dropup]="true"
          (typeaheadChange)="onChangeCidade($event)"
        >
        </sgt-typeahead-cidade>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12 col-md-6">
        <label for="subRegiao" class="col-form-label">Sub-região</label>
        <select
          class="form-control"
          name="subRegiao"
          id="subRegiao"
          [ngModel]="filter.idCidadeSubRegiao || ''"
          (ngModelChange)="
            filter.idCidadeSubRegiao = $event ? $event : null;
            onChangeCidadeSubRegiao(filter.idCidadeSubRegiao)
          "
          #subRegiao="ngModel"
          [disabled]="!filter.idCidade"
        >
          <option value="" *ngIf="!filter.idCidade">
            Selecione a cidade primeiro
          </option>
          <option value="" *ngIf="filter.idCidade">Todas as sub-regiões</option>
          <option *ngFor="let subRegiao of subRegioes" [ngValue]="subRegiao.id">
            {{ subRegiao.nome }}
          </option>
        </select>
      </div>
      <div class="form-group col-12 col-md-6">
        <label for="subRegiaoBairro" class="col-form-label"
          >Bairro da Sub-região</label
        >
        <select
          class="form-control"
          name="subRegiaoBairro"
          id="subRegiaoBairro"
          [ngModel]="filter.idCidadeSubRegiaoBairro || ''"
          (ngModelChange)="
            filter.idCidadeSubRegiaoBairro = $event ? $event : null
          "
          #subRegiaoBairro="ngModel"
          [disabled]="!filter.idCidadeSubRegiao"
        >
          <option value="" *ngIf="!filter.idCidadeSubRegiao">
            Selecione a sub-região primeiro
          </option>
          <option value="" *ngIf="filter.idCidadeSubRegiao">
            Todos os bairros das sub-regiões
          </option>
          <option *ngFor="let bairro of bairros" [ngValue]="bairro.id">
            {{ bairro.nome }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>
